import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch } from 'react-router-dom';
//Importo o componente de conteudo
import Globals from './Components/Miscelania/Globals';

//Importo as views

// Users
import Login from './Components/Users/Login';
import RecuperarSenha from './Components/Users/RecuperarSenha';
import Suspenso from './Components/Users/Suspenso';
import EmailTrainingAttendenceConfirmation from './Components/Users/EmailTrainingAttendenceConfirmation';
import UsersEditPassword from './Components/Users/UsersEditPassword';
import UsersEdit from './Components/Users/UsersEdit';
import UsersIndex from './Components/Users/UsersIndex';
import UsersAdd from './Components/Users/UsersAdd';

// Test Alerts
import TestAlertsIndex from './Components/Flights/TestAlertsIndex';
// Ptbr
import PtbrIndex from './Components/Ptbr/PtbrIndex';
// UsefulLinks
import UsefulLinksIndex from './Components/UsefulLinks/UsefulLinksIndex';
// Ptbr
import FlightOmnisIndex from './Components/FlightOmnis/FlightOmnisIndex';
// StaffScheduleRequests
import StaffScheduleRequestsChiefAnswer from './Components/StaffScheduleRequests/StaffScheduleRequestsChiefAnswer';
import StaffScheduleRequestsIndex from './Components/StaffScheduleRequests/StaffScheduleRequestsIndex';
import StaffScheduleRequestsPending from './Components/StaffScheduleRequests/StaffScheduleRequestsPending';

// SchedulePendencies
import SchedulePendenciesIndex from './Components/SchedulePendencies/SchedulePendenciesIndex';
import SchedulePendenciesPending from './Components/SchedulePendencies/SchedulePendenciesPending';

// StaffHours
import StaffFlightsAdd from './Components/Staffs/StaffFlightsAdd';
import StaffFlightHourSearch from './Components/Staffs/StaffFlightHourSearch';
// Staffs
import StaffsIndex from './Components/Staffs/StaffsIndex';
import StaffsIndexAll from './Components/Staffs/StaffsIndexAll';
import StaffsIndexActive from './Components/Staffs/StaffsIndexActive';
import StaffsDesignationsIndex from './Components/Staffs/StaffsDesignationsIndex';
import StaffsInactiveIndex from './Components/Staffs/StaffsInactiveIndex';
import CvoIndex from './Components/Staffs/CvoIndex';
import CvoInactiveIndex from './Components/Staffs/CvoInactiveIndex';
import MasterIndex from './Components/Staffs/MasterIndex';
import MasterInactiveIndex from './Components/Staffs/MasterInactiveIndex';
import StaffsEdit from './Components/Staffs/StaffsEdit';
import StaffsAdd from './Components/Staffs/StaffsAdd';
import StaffsIcao from './Components/Staffs/StaffsIcao';
import StaffsCerficationsIndex from './Components/Staffs/StaffsCerficationsIndex';
import StaffsCerficationsMultipleFilter from './Components/Staffs/StaffsCerficationsMultipleFilter';
import StaffsCerficationsConsolidated from './Components/Staffs/StaffsCerficationsConsolidated';
import StaffsCerficationsOutdatedIndex from './Components/Staffs/StaffsCerficationsOutdatedIndex';
import StaffsAsoElectrocardsOutdatedIndex from './Components/Staffs/StaffsAsoElectrocardsOutdatedIndex';
import StaffsWithoutCerficationsIndex from './Components/Staffs/StaffsWithoutCerficationsIndex';
import StaffSeniorityIndex from './Components/Staffs/StaffSeniorityIndex';
import StaffsWithoutRoleIndex from './Components/Staffs/StaffsWithoutRoleIndex';
import StaffInactiveWithoutRoleIndex from './Components/Staffs/StaffInactiveWithoutRoleIndex';
import StaffCertificationControl from './Components/Staffs/StaffCertificationControl';
import StaffDocQpulseIndex from './Components/Staffs/StaffDocQpulseIndex';
import CvoCerficationsIndex from './Components/Staffs/CvoCerficationsIndex';
import CvoWithoutCerficationsIndex from './Components/Staffs/CvoWithoutCerficationsIndex';
import MasterCerficationsIndex from './Components/Staffs/MasterCerficationsIndex';
import MasterWithoutCerficationsIndex from './Components/Staffs/MasterWithoutCerficationsIndex';

// Companies
import CompaniesIndex from './Components/Companies/CompaniesIndex';
import CompaniesEdit from './Components/Companies/CompaniesEdit';
import CompaniesAdd from './Components/Companies/CompaniesAdd';
// Bases
import BasesIndex from './Components/Bases/BasesIndex';
import BasesEdit from './Components/Bases/BasesEdit';
import BasesAdd from './Components/Bases/BasesAdd';
import AircraftBasesIndex from './Components/AircraftBases/AircraftBasesIndex';
import AircraftBasesAdd from './Components/AircraftBases/AircraftBasesAdd';

// Flights
import FlightsIndex from './Components/Flights/FlightsIndex';
import FlightsAdd from './Components/Flights/FlightsAdd';

// Aircrafts
import AircraftsIndex from './Components/Aircrafts/AircraftsIndex';
import AircraftsEdit from './Components/Aircrafts/AircraftsEdit';
import AircraftsAdd from './Components/Aircrafts/AircraftsAdd';
import AircraftsMonth from './Components/Aircrafts/AircraftsMonth';
import AircraftsYear from './Components/Aircrafts/AircraftsYear';

// Availabilities
import AvailabilitiesEnded from './Components/Availabilities/AvailabilitiesEnded';
import AvailabilitiesIndex from './Components/Availabilities/AvailabilitiesIndex';
import AvailabilitiesActives from './Components/Availabilities/AvailabilitiesActives';
import AvailabilitiesEdit from './Components/Availabilities/AvailabilitiesEdit';
import AvailabilitiesAdd from './Components/Availabilities/AvailabilitiesAdd';

// AircraftModels
import AircraftModelsIndex from './Components/AircraftModels/AircraftModelsIndex';
import AircraftModelsEdit from './Components/AircraftModels/AircraftModelsEdit';
import AircraftModelsAdd from './Components/AircraftModels/AircraftModelsAdd';

// AircraftManeuveringAreaPeriods
import AircraftManeuveringAreaPeriodsIndex from './Components/AircraftManeuveringAreaPeriods/AircraftManeuveringAreaPeriodsIndex';
import AircraftManeuveringAreaPeriodsEdit from './Components/AircraftManeuveringAreaPeriods/AircraftManeuveringAreaPeriodsEdit';
import AircraftManeuveringAreaPeriodsAdd from './Components/AircraftManeuveringAreaPeriods/AircraftManeuveringAreaPeriodsAdd';

// AbnormalOccurrenceTypes
import AbnormalOccurrenceTypesIndex from './Components/AbnormalOccurrenceTypes/AbnormalOccurrenceTypesIndex';
import AbnormalOccurrenceTypesEdit from './Components/AbnormalOccurrenceTypes/AbnormalOccurrenceTypesEdit';
import AbnormalOccurrenceTypesAdd from './Components/AbnormalOccurrenceTypes/AbnormalOccurrenceTypesAdd';
// MaintenanceInterventionTypes
import MaintenanceInterventionTypesIndex from './Components/MaintenanceInterventionTypes/MaintenanceInterventionTypesIndex';
import MaintenanceInterventionTypesEdit from './Components/MaintenanceInterventionTypes/MaintenanceInterventionTypesEdit';
import MaintenanceInterventionTypesAdd from './Components/MaintenanceInterventionTypes/MaintenanceInterventionTypesAdd';

// Duties
import DutiesIndex from './Components/Duties/DutiesIndex';
import DutiesEdit from './Components/Duties/DutiesEdit';
import DutiesAdd from './Components/Duties/DutiesAdd';

// Locations
import LocationsIndex from './Components/Locations/LocationsIndex';
import LocationsEdit from './Components/Locations/LocationsEdit';
import LocationsAdd from './Components/Locations/LocationsAdd';

// LocationTypes
import LocationTypesIndex from './Components/LocationTypes/LocationTypesIndex';
import LocationTypesEdit from './Components/LocationTypes/LocationTypesEdit';
import LocationTypesAdd from './Components/LocationTypes/LocationTypesAdd';

// AirportOperators
import AirportOperatorsIndex from './Components/AirportOperators/AirportOperatorsIndex';
import AirportOperatorsEdit from './Components/AirportOperators/AirportOperatorsEdit';
import AirportOperatorsAdd from './Components/AirportOperators/AirportOperatorsAdd';

// AirspaceResponsibles
import AirspaceResponsiblesIndex from './Components/AirspaceResponsibles/AirspaceResponsiblesIndex';
import AirspaceResponsiblesEdit from './Components/AirspaceResponsibles/AirspaceResponsiblesEdit';
import AirspaceResponsiblesAdd from './Components/AirspaceResponsibles/AirspaceResponsiblesAdd';

// FlightTypes
import FlightTypesIndex from './Components/FlightTypes/FlightTypesIndex';
import FlightTypesEdit from './Components/FlightTypes/FlightTypesEdit';
import FlightTypesAdd from './Components/FlightTypes/FlightTypesAdd';

// OperationTypes
import OperationTypesIndex from './Components/OperationTypes/OperationTypesIndex';
import OperationTypesEdit from './Components/OperationTypes/OperationTypesEdit';
import OperationTypesAdd from './Components/OperationTypes/OperationTypesAdd';

// FuelSupplierLocations
import FuelSupplierLocationsEdit from './Components/FuelSupplierLocations/FuelSupplierLocationsEdit';

// FuelSuppliers
import FuelSuppliersIndex from './Components/FuelSuppliers/FuelSuppliersIndex';
import FuelSuppliersEdit from './Components/FuelSuppliers/FuelSuppliersEdit';
import FuelSuppliersAdd from './Components/FuelSuppliers/FuelSuppliersAdd';

// StaffLicenses
import StaffLicensesIndex from './Components/StaffLicenses/StaffLicensesIndex';

// StaffPapers
import StaffPaperCustomRequisitionControl from './Components/StaffPapers/Control/StaffPaperCustomRequisitionControl';
import StaffPapersOpen from './Components/StaffPapers/StaffPapersOpen';
import StaffPapersManager from './Components/StaffPapers/StaffPapersManager';
import StaffPapersIndex from './Components/StaffPapers/StaffPapersIndex';
import StaffPapersDone from './Components/StaffPapers/StaffPapersDone';
import StaffPapersEdit from './Components/StaffPapers/StaffPapersEdit';
import StaffPapersAdd from './Components/StaffPapers/StaffPapersAdd';
import StaffPapersControl from './Components/StaffPapers/Control/StaffPapersControl';
import StaffPapersControleManager from './Components/StaffPapers/Control/StaffPapersControleManager';

// StaffGraduations
import StaffGraduationsIndex from './Components/StaffGraduations/StaffGraduationsIndex';

// StaffCopilotAuthorizations
import StaffCopilotAuthorizationsIndex from './Components/StaffCopilotAuthorizations/StaffCopilotAuthorizationsIndex';

// Roles
import RolesIndex from './Components/Roles/RolesIndex';
import RolesEdit from './Components/Roles/RolesEdit';
import RolesAdd from './Components/Roles/RolesAdd';

// Sectors
import SectorsIndex from './Components/Sectors/SectorsIndex';
import SectorsEdit from './Components/Sectors/SectorsEdit';
import SectorsAdd from './Components/Sectors/SectorsAdd';

// Trainings
import TrainingsIndex from './Components/Trainings/TrainingsIndex';
import TrainingsEdit from './Components/Trainings/TrainingsEdit';
import TrainingsAdd from './Components/Trainings/TrainingsAdd';

// Suppliers
import SuppliersIndex from './Components/Suppliers/SuppliersIndex';
import SuppliersEdit from './Components/Suppliers/SuppliersEdit';
import SuppliersAdd from './Components/Suppliers/SuppliersAdd';

// CertificationSuppliers
import CertificationSuppliersToExpireIndex from './Components/CertificationSuppliers/CertificationSuppliersToExpireIndex';
// Certifications
import CertificationsCompleteIndex from './Components/Certifications/CertificationsCompleteIndex';
import CertificationsIndex from './Components/Certifications/CertificationsIndex';
import CertificationsAdd from './Components/Certifications/CertificationsAdd';
import CertificationsEdit from './Components/Certifications/CertificationsEdit';

// Contracts
import ContractsAdd from './Components/Contracts/ContractsAdd';
import ContractsEdit from './Components/Contracts/ContractsEdit';
import ContractsIndex from './Components/Contracts/ContractsIndex';
import ContractsSearch from './Components/Contracts/ContractsSearch';

// Designations
import DesignationsAdd from './Components/Designations/DesignationsAdd';
import DesignationsEdit from './Components/Designations/DesignationsEdit';
import DesignationsIndex from './Components/Designations/DesignationsIndex';

// WarningExperiences
import WarningExperiencesEdit from './Components/WarningExperiences/WarningExperiencesEdit';

// Clients
import ClientsAdd from './Components/Clients/ClientsAdd';
import ClientsEdit from './Components/Clients/ClientsEdit';
import ClientsIndex from './Components/Clients/ClientsIndex';

// Gratifications
import GratificationsAdd from './Components/Gratifications/GratificationsAdd';
import GratificationsEdit from './Components/Gratifications/GratificationsEdit';
import GratificationsIndex from './Components/Gratifications/GratificationsIndex';

// Processes
import ProcessesAdd from './Components/Processes/ProcessesAdd';
import ProcessesEdit from './Components/Processes/ProcessesEdit';
import ProcessesIndex from './Components/Processes/ProcessesIndex';

// Documents
import DocumentsAdd from './Components/Documents/DocumentsAdd';
import DocumentsEdit from './Components/Documents/DocumentsEdit';
import DocumentsIndex from './Components/Documents/DocumentsIndex';

// Emails
import EmailsEdit from './Components/Emails/EmailsEdit';
import EmailsIndex from './Components/Emails/EmailsIndex';

// Logs
import LogsIndex from './Components/Logs/LogsIndex';


// Import
import ImportIndex from './Components/Import/ImportIndex';

// AircraftLogbooks (EDB)
import AircraftLogbookReset from './Components/AircraftLogbooks/AircraftLogbookReset';
import AircraftLogbooksAdd from './Components/AircraftLogbooks/AircraftLogbooksAdd';
import AircraftLogbooksDashboard from './Components/AircraftLogbooks/AircraftLogbooksDashboard';
import AircraftLogbooksEdit from './Components/AircraftLogbooks/AircraftLogbooksEdit';
import AircraftLogbooksIndex from './Components/AircraftLogbooks/AircraftLogbooksIndex';
import AircraftLogbooksSearch from './Components/AircraftLogbooks/AircraftLogbooksSearch';

// AircraftLogbookReportActionDeferredItems (EDB ACR)
import AircraftLogbookReportActionEdit from './Components/AircraftLogbookReportActionDeferredItems/AircraftLogbookReportActionEdit';
import AircraftLogbookReportActionsIndexClosed from './Components/AircraftLogbookReportActionDeferredItems/AircraftLogbookReportActionsIndexClosed';
import AircraftLogbookReportActionsIndexOpened from './Components/AircraftLogbookReportActionDeferredItems/AircraftLogbookReportActionsIndexOpened';

// Schedules
import SchedulesAdd from './Components/Schedules/SchedulesAdd';
import SchedulesElaborate from './Components/Schedules/SchedulesElaborate';
import SchedulesEdit from './Components/Schedules/SchedulesEdit';
import SchedulesIndex from './Components/Schedules/SchedulesIndex';
import ScheduleMasterIndex from './Components/Schedules/ScheduleMasterIndex';
import ScheduleMasterAdd from './Components/Schedules/ScheduleMasterAdd';
import ScheduleMasterEdit from './Components/Schedules/ScheduleMasterEdit';
import ScheduleCvoIndex from './Components/Schedules/ScheduleCvoIndex';
import ScheduleCvoAdd from './Components/Schedules/ScheduleCvoAdd';
import ScheduleCvoEdit from './Components/Schedules/ScheduleCvoEdit';
import ScheduleTrainingsIndex from './Components/Schedules/ScheduleTrainingsIndex';
import ScheduleTrainingsAdd from './Components/Schedules/ScheduleTrainingsAdd';
import ScheduleTrainingsEdit from './Components/Schedules/ScheduleTrainingsEdit';
import ScheduleTrainingsDuplicate from './Components/Schedules/ScheduleTrainingsDuplicate';
import ScheduleCvoDuplicate from './Components/Schedules/ScheduleCvoDuplicate';
import ScheduleMasterDuplicate from './Components/Schedules/ScheduleMasterDuplicate';
import SchedulesDuplicate from './Components/Schedules/SchedulesDuplicate';
import SchedulePlanningIndex from './Components/Schedules/SchedulePlanningIndex';
import SchedulePlanningSimulation from './Components/Schedules/SchedulePlanningSimulation';
import SchedulePlanningAdd from './Components/Schedules/SchedulePlanningAdd';
import SchedulePlanningEdit from './Components/Schedules/SchedulePlanningEdit';

// StaffFlightTotals
import StaffFlightTotalsDisponibility from './Components/StaffFlightTotals/StaffFlightTotalsDisponibility';

// ScheduleBases
import ScheduleBasesAdd from './Components/ScheduleBases/ScheduleBasesAdd';
import ScheduleBasesEdit from './Components/ScheduleBases/ScheduleBasesEdit';
import ScheduleBasesIndex from './Components/ScheduleBases/ScheduleBasesIndex';
import ScheduleGradeBaseEdit from './Components/ScheduleGrades/ScheduleGradeBaseEdit';

// ScheduleGrades
import ScheduleGradeAlerts from './Components/ScheduleGrades/ScheduleGradeAlerts';
import ScheduleGradesEdit from './Components/ScheduleGrades/ScheduleGradesEdit';
import ScheduleGradesAlternate from './Components/ScheduleGrades/ScheduleGradesAlternate';
import ScheduleGradesTrainings from './Components/ScheduleGrades/ScheduleGradesTrainings';

// ScheduleInitials
import ScheduleInitialsAdd from './Components/ScheduleInitials/ScheduleInitialsAdd';
import ScheduleInitialsEdit from './Components/ScheduleInitials/ScheduleInitialsEdit';
import ScheduleInitialsIndex from './Components/ScheduleInitials/ScheduleInitialsIndex';

// ScheduleRegime
import ScheduleRegime from './Components/ScheduleRegime/ScheduleRegime';

// TrainingCertificationStaffPayments
import PaymentHoursAdd from './Components/TrainingCertificationStaffPayments/PaymentHoursAdd';
import PaymentDailyAdd from './Components/TrainingCertificationStaffPayments/PaymentDailyAdd';
import PaymentDailyInternationalAdd from './Components/TrainingCertificationStaffPayments/PaymentDailyInternationalAdd';
import PaymentDailyExtraAdd from './Components/TrainingCertificationStaffPayments/PaymentDailyExtraAdd';
import PaymentHoursOpened from './Components/TrainingCertificationStaffPayments/PaymentHoursOpened';
import PaymentDailyExtraOpened from './Components/TrainingCertificationStaffPayments/PaymentDailyExtraOpened';
import PaymentDailyOpened from './Components/TrainingCertificationStaffPayments/PaymentDailyOpened';
import PaymentCheckOpened from './Components/TrainingCertificationStaffPayments/PaymentCheckOpened';
import StaffDebt from './Components/TrainingCertificationStaffPayments/StaffDebt';
import PaymentDebtAdd from './Components/TrainingCertificationStaffPayments/PaymentDebtAdd';
import PaymentDebtEdit from './Components/TrainingCertificationStaffPayments/PaymentDebtEdit';
import PaymentCreditAdd from './Components/TrainingCertificationStaffPayments/PaymentCreditAdd';
import PaymentCreditEdit from './Components/TrainingCertificationStaffPayments/PaymentCreditEdit';

import PaymentRequestScheduleDistanceIndex from './Components/PaymentRequests/PaymentRequestScheduleDistanceIndex';
import PaymentRequestTrainingDistanceIndex from './Components/PaymentRequests/PaymentRequestTrainingDistanceIndex';
import PaymentRequestScheduleTransportIndex from './Components/PaymentRequests/PaymentRequestScheduleTransportIndex';
import PaymentRequestTrainingTransportIndex from './Components/PaymentRequests/PaymentRequestTrainingTransportIndex';


// SchedulePayments
import SchedulePaymentHoursAdd from './Components/SchedulePayments/PaymentHoursAdd';
import SchedulePaymentDailyAdd from './Components/SchedulePayments/PaymentDailyAdd';
import SchedulePaymentDistanceAdd from './Components/SchedulePayments/PaymentDistanceAdd';
import SchedulePaymentExtraAdd from './Components/SchedulePayments/PaymentExtraAdd';
import SchedulePaymentTransportAdd from './Components/SchedulePayments/PaymentTransportAdd';
import SchedulePaymentDailyBaseAdd from './Components/SchedulePayments/PaymentDailyBaseAdd';
import SchedulePaymentHoursOpened from './Components/SchedulePayments/PaymentHoursOpened';
import SchedulePaymentDailyOpened from './Components/SchedulePayments/PaymentDailyOpened';
import SchedulePaymentBaseChiefOpened from './Components/SchedulePayments/PaymentBaseChiefOpened';
import SchedulePaymentDistanceOpened from './Components/SchedulePayments/PaymentDistanceOpened';
import SchedulePaymentTransportOpened from './Components/SchedulePayments/PaymentTransportOpened';
import SchedulePaymentExtraOpened from './Components/SchedulePayments/PaymentExtraOpened';


//PaymentOrders
import PaymentOrdersAdd from './Components/PaymentOrders/PaymentOrdersAdd';
import PaymentOrdersEdit from './Components/PaymentOrders/PaymentOrdersEdit';
import PaymentOrdersSentIndex from './Components/PaymentOrders/PaymentOrdersSentIndex';
import PaymentOrdersOpenedIndex from './Components/PaymentOrders/PaymentOrdersOpenedIndex';

// Incompatibilities
import IncompatibilitiesIndex from './Components/Incompatibilities/IncompatibilitiesIndex';

// PaymentValues
import PaymentValuesEdit from './Components/PaymentValues/PaymentValuesEdit';

// Payments
import StaffFlightPaymentHoursOpened from './Components/Payments/PaymentHoursOpened';



// -------------------------- VOOS

// FlightReportRefuels
import FlightReportRefuelsAdd from './Components/FlightReportRefuels/FlightReportRefuelsAdd';
import FlightReportRefuelsEdit from './Components/FlightReportRefuels/FlightReportRefuelsEdit';
import FlightReportRefuelsIndex from './Components/FlightReportRefuels/FlightReportRefuelsIndex';

// FlightReports
import FlightReportsIndex from './Components/FlightReports/FlightReportsIndex';
import FlightReportsEdit from './Components/FlightReports/FlightReportsEdit';
import FlightReportsAdd from './Components/FlightReports/FlightReportsAdd';

// FlightReports - Controles
import FlightReportApprovals from './Components/FlightReports/Control/FlightReportApprovals';
import FlightReportQuantity from './Components/FlightReports/Control/FlightReportQuantity';
import FlightReportsMain from './Components/FlightReports/Control/FlightReportsMain';
import FlightReportsAircrafts from './Components/FlightReports/Control/FlightReportsAircrafts';
import FlightReportsRefuels from './Components/FlightReports/Control/FlightReportsRefuels';
import FlightReportsStaffHours from './Components/FlightReports/Control/FlightReportsStaffHours';
import FlightReportsConsumption from './Components/FlightReports/Control/FlightReportsConsumption';
import FlightReportsConsumptionDisponibility from './Components/FlightReports/Control/FlightReportsConsumptionDisponibility';
import FlightReportsAbnormalOcurrences from './Components/FlightReports/Control/FlightReportsAbnormalOcurrences';
import FlightReportsDestinies from './Components/FlightReports/Control/FlightReportsDestinies';
import FlightReportsLandingTimes from './Components/FlightReports/Control/FlightReportsLandingTimes';
import FlightReportsPayloads from './Components/FlightReports/Control/FlightReportsPayloads';
import FlightReportsLegDifferences from './Components/FlightReports/Control/FlightReportsLegDifferences';
import FlightReportsAvailabilities from './Components/FlightReports/Control/FlightReportsAvailabilities';
import FlightReportsAvailabilitiesSearch from './Components/FlightReports/Control/FlightReportsAvailabilitiesSearch';
import FlightReportsHoursReport from './Components/FlightReports/Control/FlightReportsHoursReport';
import FlightReportsMeasurementCheck from './Components/FlightReports/Control/FlightReportsMeasurementCheck';
import FlightReportsPontuality from './Components/FlightReports/Control/FlightReportsPontuality';
import FlightReportsXMLMultiple from './Components/FlightReports/Control/FlightReportsXMLMultiple';
import FlightReportsDBMultiple from './Components/FlightReports/Control/FlightReportsDBMultiple';
import FlightReportsMainMultiple from './Components/FlightReports/Control/FlightReportsMainMultiple';
import NightimeExperience from './Components/FlightReports/Control/NightimeExperience';
import FlightReportLegFees from './Components/FlightReports/Control/FlightReportLegFees';

// Warnings
import WarningsIndex from './Components/Warnings/WarningsIndex';
import WarningsEdit from './Components/Warnings/WarningsEdit';

// -------------------------- FRMS

// Tasks
import TasksAdd from './Components/Tasks/TasksAdd';
import TasksEdit from './Components/Tasks/TasksEdit';
import TasksIndex from './Components/Tasks/TasksIndex';

// DrowsinessSchedules
import DrowsinessSchedulesAdd from './Components/DrowsinessSchedules/DrowsinessSchedulesAdd';
import DrowsinessSchedulesIndex from './Components/DrowsinessSchedules/DrowsinessSchedulesIndex';
import DrowsinessSchedulesEdit from './Components/DrowsinessSchedules/DrowsinessSchedulesEdit';

// Fatigue
import FatigueIndex from './Components/Fatigue/FatigueIndex';
import FatigueAdd from './Components/Fatigue/FatigueAdd';
import FatigueEdit from './Components/Fatigue/FatigueEdit';

// FatigueTest
import FatigueTestsIndex from './Components/FatigueTests/FatigueTestsIndex';

// FatigueReason & FatigueReasonReport
import FatigueReasonsEdit from './Components/FatigueReasons/FatigueReasonsEdit';
import FatigueReasonReportsAdd from './Components/FatigueReasons/FatigueReasonReportsAdd';
import FatigueReasonReportsIndex from './Components/FatigueReasons/FatigueReasonReportsIndex';
import FatigueReasonReportsArchived from './Components/FatigueReasons/FatigueReasonReportsArchived';

// FatigueAuxiliaryReport
import SearchAuxiliaryReport from './Components/FatigueAuxiliaryReports/SearchAuxiliaryReport';

//  RFMS Reports
import StaffRfmsReportAdmAdd from './Components/StaffRfmsReport/StaffRfmsReportAdmAdd';
import StaffRfmsReportAdmEdit from './Components/StaffRfmsReport/StaffRfmsReportAdmEdit';
import StaffRfmsReportAdd from './Components/StaffRfmsReport/StaffRfmsReportAdd';
import StaffRfmsReportEdit from './Components/StaffRfmsReport/StaffRfmsReportEdit';
import StaffRfmsReportIndex from './Components/StaffRfmsReport/StaffRfmsReportIndex';
import StaffRfmsReportFilter from './Components/StaffRfmsReport/StaffRfmsReportFilter';
import StaffRfmsReportIncidentFatigueFilter from './Components/StaffRfmsReport/StaffRfmsReportIncidentFatigueFilter';
import SimulatorStaffRfmsReport from './Components/StaffRfmsReport/SimulatorStaffRfmsReport';
import StaffRfmsReportMissing from './Components/StaffRfmsReport/StaffRfmsReportMissing';
import StaffRfmsReportSearch from './Components/StaffRfmsReport/StaffRfmsReportSearch';
import StaffRfmsReportAdjustHours from './Components/StaffRfmsReport/StaffRfmsReportAdjustHours';
import StaffRfmsReportSiglaAdd from './Components/StaffRfmsReport/StaffRfmsReportSiglaAdd';
import StaffRfmsReportSiglaAvaliation from './Components/StaffRfmsReport/StaffRfmsReportSiglaAvaliation';
import StaffRfmsReportEvents from './Components/StaffRfmsReport/StaffRfmsReportEvents';

// EffectivenessSections
import EffectivenessSectionsAdd from './Components/EffectivenessSections/EffectivenessSectionsAdd';
import EffectivenessSectionsIndex from './Components/EffectivenessSections/EffectivenessSectionsIndex';
import EffectivenessSectionsEdit from './Components/EffectivenessSections/EffectivenessSectionsEdit';

// FatigueEffectiveness
import FatigueEffectivenessAdd from './Components/FatigueEffectiveness/FatigueEffectivenessAdd';
import FatigueEffectivenessSearch from './Components/FatigueEffectiveness/FatigueEffectivenessSearch';
import FatigueEffectivenessIndex from './Components/FatigueEffectiveness/FatigueEffectivenessIndex';
import FatigueEffectivenessEdit from './Components/FatigueEffectiveness/FatigueEffectivenessEdit';

// SettingsEdit
import SettingsEdit from './Components/Settings/SettingsEdit';

class App extends Component {
  // constructor
  constructor(props, context) {
    super(props, context);

    this.state = {
      permission: false,
    }

  }
    componentDidMount() {
        var url_login = config.get('url') + '/usuario/login';
        var url_suspended = config.get('url') + '/usuario/suspenso';
        var url_recovery_pw = config.get('url') + '/usuario/recuperar_senha';
        var url_fuel_supplier_location_token = 'fornecedor/combustivel/localidade/editar';
        var url_actual = window.location.href;
        if(url_actual !== url_login && url_actual !== url_suspended && url_actual !== url_recovery_pw && !url_actual.includes(url_fuel_supplier_location_token)) {
          // busco as infos
          var params = JSON.parse(localStorage.getItem("cid"));
          // Verifico se há algum storage setado
          if(params === null || typeof params === 'undefined') {

            window.location.replace(config.get('url') + '/usuario/login');
          } else {

            // Verifico se o cid acode setado
            if(params.acode === null || typeof params.acode === 'undefined') {

              window.location.replace(config.get('url') + '/usuario/login');
            } else {
              this.setState({permission: true});
            }
          }
        } else {
          this.setState({permission: true});
        }
    }
  render() {
    return (
      <div>
        {
          (this.state.permission === false) ? '' :
            <div>
              <BrowserRouter>
                <Switch>
                  {/* staff hours */}
                  <Route path="/funcionario/horas/voos/:id" component={StaffFlightsAdd} />
                  <Route path="/tripulantes/pesquisa/voos" component={StaffFlightHourSearch} />
                  {/* staffs */}
                  <Route path="/tripulantes/ativos" component={StaffsIndex} />
                  <Route path="/colaboradores/ativos" component={StaffsIndexActive} />
                  <Route path="/colaboradores/todos" component={StaffsIndexAll} />
                  <Route path="/tripulantes/designacoes" component={StaffsDesignationsIndex} />
                  <Route path="/tripulantes/desligados" component={StaffsInactiveIndex} />
                  <Route path="/CVO/ativos" component={CvoIndex} />
                  <Route path="/CVO/desligados" component={CvoInactiveIndex} />
                  <Route path="/mestres-de-carga/ativos" component={MasterIndex} />
                  <Route path="/mestres-de-carga/desligados" component={MasterInactiveIndex} />
                  <Route path="/funcionario/cadastrar" component={StaffsAdd} />
                  <Route path="/funcionario/editar/:id" component={StaffsEdit} />
                  <Route path="/funcionarios/icaos" component={StaffsIcao} />
                  <Route path="/tripulantes/certificados/vencimento" component={StaffsCerficationsOutdatedIndex} />
                  <Route path="/tripulantes/aso/eletrocadiograma/vencimento" component={StaffsAsoElectrocardsOutdatedIndex} />
                  <Route path="/tripulantes/certificados" component={StaffsCerficationsIndex} />
                  <Route path="/tripulantes/filtro/certificados" component={StaffsCerficationsMultipleFilter} />
                  <Route path="/tripulantes/treinamentos/consolidados" component={StaffsCerficationsConsolidated} />
                  <Route path="/tripulantes/sem/certificados" component={StaffsWithoutCerficationsIndex} />
                  <Route path="/tripulantes/senioridade" component={StaffSeniorityIndex} />
                  <Route path="/funcionarios/sem/cargo/demitidos" component={StaffInactiveWithoutRoleIndex} />
                  <Route path="/funcionarios/sem/cargo" component={StaffsWithoutRoleIndex} />
                  <Route path="/funcionarios/controle/certificados" component={StaffCertificationControl} />
                  <Route path="/funcionarios/documentos/q-pulse" component={StaffDocQpulseIndex} />
                  <Route path="/cvo/certificados" component={CvoCerficationsIndex} />
                  <Route path="/cvo/sem/certificados" component={CvoWithoutCerficationsIndex} />
                  <Route path="/mestres-de-carga/certificados" component={MasterCerficationsIndex} />
                  <Route path="/mestres-de-carga/sem/certificados" component={MasterWithoutCerficationsIndex} />

                  {/* Usuários */}
                  <Route path="/email/confirmacao/:token" component={EmailTrainingAttendenceConfirmation} />
                  <Route path="/usuario/login" component={Login} />
                  <Route path="/usuario/recuperar_senha" component={RecuperarSenha} />
                  <Route path="/usuario/suspenso" component={Suspenso} />

                  {/* Companies */}
                  <Route path="/empresa/cadastrar" component={CompaniesAdd} />
                  <Route path="/empresa/editar/:id" component={CompaniesEdit} />
                  <Route path="/empresas" component={CompaniesIndex} />

                  {/* Bases */}
                  <Route path="/base/cadastrar" component={BasesAdd} />
                  <Route path="/base/editar/:id" component={BasesEdit} />
                  <Route path="/bases" component={BasesIndex} />
                  <Route path="/frotas/disponiveis" component={AircraftBasesIndex} />
                  <Route path="/adicionar/frota/disponivel" component={AircraftBasesAdd} />
                  {/* PTBR */}
                  <Route path="/referencias/ptbr" component={PtbrIndex} />
                  {/* Atrasos */}
                  <Route path="/justificativas/atraso/internas" component={FlightOmnisIndex} />
                  {/* Flights */}
                  <Route path="/voo/cadastrar" component={FlightsAdd} />
                  <Route path="/voos/resumo" component={FlightsIndex} />
                  {/* AircraftModels */}
                  <Route path="/aeronave/modelo/cadastrar" component={AircraftModelsAdd} />
                  <Route path="/aeronave/modelo/editar/:id" component={AircraftModelsEdit} />
                  <Route path="/aeronave/modelos" component={AircraftModelsIndex} />
                  {/* AircraftManeuveringAreaPeriods */}
                  <Route path="/reboque/aeronave/cadastrar" component={AircraftManeuveringAreaPeriodsAdd} />
                  <Route path="/reboque/aeronave/editar/:id" component={AircraftManeuveringAreaPeriodsEdit} />
                  <Route path="/reboque/aeronaves" component={AircraftManeuveringAreaPeriodsIndex} />
                  {/* AbnormalOccurrenceTypes */}
                  <Route path="/ocorrencia/anormal/cadastrar" component={AbnormalOccurrenceTypesAdd} />
                  <Route path="/ocorrencia/anormal/editar/:id" component={AbnormalOccurrenceTypesEdit} />
                  <Route path="/ocorrencias/anormais" component={AbnormalOccurrenceTypesIndex} />
                  {/* MaintenanceInterventionTypes */}
                  <Route path="/manutencao/intervencao/cadastrar" component={MaintenanceInterventionTypesAdd} />
                  <Route path="/manutencao/intervencao/editar/:id" component={MaintenanceInterventionTypesEdit} />
                  <Route path="/manutencao/intervencoes" component={MaintenanceInterventionTypesIndex} />
                  {/* Duties */}
                  <Route path="/funcao/bordo/cadastrar" component={DutiesAdd} />
                  <Route path="/funcao/bordo/editar/:id" component={DutiesEdit} />
                  <Route path="/funcoes/bordo" component={DutiesIndex} />
                  {/* Locations */}
                  <Route path="/local/cadastrar" component={LocationsAdd} />
                  <Route path="/local/editar/:id" component={LocationsEdit} />
                  <Route path="/locais" component={LocationsIndex} />
                  {/* LocationTypes */}
                  <Route path="/tipo/local/cadastrar" component={LocationTypesAdd} />
                  <Route path="/tipo/local/editar/:id" component={LocationTypesEdit} />
                  <Route path="/tipos/local" component={LocationTypesIndex} />
                  {/* AirportOperators */}
                  <Route path="/operador/cadastrar" component={AirportOperatorsAdd} />
                  <Route path="/operador/editar/:id" component={AirportOperatorsEdit} />
                  <Route path="/operadores" component={AirportOperatorsIndex} />
                  {/* AirportOperators */}
                  <Route path="/controlador/cadastrar" component={AirspaceResponsiblesAdd} />
                  <Route path="/controlador/editar/:id" component={AirspaceResponsiblesEdit} />
                  <Route path="/controladores" component={AirspaceResponsiblesIndex} />
                  {/* FlightTypes */}
                  <Route path="/tipo/voo/cadastrar" component={FlightTypesAdd} />
                  <Route path="/tipo/voo/editar/:id" component={FlightTypesEdit} />
                  <Route path="/tipos/voo" component={FlightTypesIndex}FlightTypes />
                  {/* OperationTypes */}
                  <Route path="/tipo/operacao/cadastrar" component={OperationTypesAdd} />
                  <Route path="/tipo/operacao/editar/:id" component={OperationTypesEdit} />
                  <Route path="/tipos/operacao" component={OperationTypesIndex} />
                  {/* FuelSupplierLocations */}
                  <Route path="/fornecedor/combustivel/localidade/editar/:token" component={FuelSupplierLocationsEdit} />
                  {/* FuelSuppliers */}
                  <Route path="/fornecedor/combustivel/cadastrar" component={FuelSuppliersAdd} />
                  <Route path="/fornecedor/combustivel/editar/:id" component={FuelSuppliersEdit} />
                  <Route path="/fornecedores/combustivel" component={FuelSuppliersIndex} />
                  {/* StaffLicenses */}
                  <Route path="/tripulantes/pesquisa/habilitacoes" component={StaffLicensesIndex} />
                  {/* StaffPapers */}
                  <Route path="/papeletas/controle" component={StaffPapersControl} />
                  <Route path="/papeletas" component={StaffPapersIndex} />
                  <Route path="/papeleta/editar/:id" component={StaffPapersEdit} />
                  <Route path="/papeleta/consulta/gestor" component={StaffPapersControleManager} />
                  <Route path="/papeleta/cadastrar" component={StaffPapersAdd} />
                  <Route path="/papeletas/controle/requisitos/personalizados" component={StaffPaperCustomRequisitionControl} />
                  {/* StaffGraduations */}
                  <Route path="/funcionario/graduacoes" component={StaffGraduationsIndex} />
                  {/* StaffCopilotAuthorizations */}
                  <Route path="/funcionario/copilotos/autorizacoes" component={StaffCopilotAuthorizationsIndex} />
                  {/* Aircraft */}
                  <Route path="/aeronaves/movimentacao/mensal" component={AircraftsMonth} />
                  <Route path="/aeronaves/movimentacao/anual" component={AircraftsYear} />
                  <Route path="/aeronave/cadastrar" component={AircraftsAdd} />
                  <Route path="/aeronave/editar/:id" component={AircraftsEdit} />
                  <Route path="/aeronaves" component={AircraftsIndex} />
                  {/* Availability */}
                  <Route path="/indisponibilidade/cadastrar" component={AvailabilitiesAdd} />
                  <Route path="/indisponibilidade/editar/:id" component={AvailabilitiesEdit} />
                  <Route path="/indisponibilidades/arquivadas" component={AvailabilitiesEnded} />
                  <Route path="/indisponibilidade/aeronaves" component={AvailabilitiesActives} />
                  <Route path="/indisponibilidades" component={AvailabilitiesIndex} />
                  {/* Role */}
                  <Route path="/cargo/cadastrar" component={RolesAdd} />
                  <Route path="/cargo/editar/:id" component={RolesEdit} />
                  <Route path="/cargos" component={RolesIndex} />
                  {/* FlightReportRefuel */}
                  <Route path="/abastecimento/cadastrar" component={FlightReportRefuelsAdd} />
                  {/* Sectors */}
                  <Route path="/setor/cadastrar" component={SectorsAdd} />
                  <Route path="/setor/editar/:id" component={SectorsEdit} />
                  <Route path="/setores" component={SectorsIndex} />
                  <Route path="/abastecimento/editar/:id" component={FlightReportRefuelsEdit} />
                  <Route path="/abastecimentos" component={FlightReportRefuelsIndex} />
                  {/* FlightReport */}
                  <Route path="/relatorio/voo/cadastrar" component={FlightReportsAdd} />
                  <Route path="/relatorio/voo/editar/:id" component={FlightReportsEdit} />
                  <Route path="/relatorios/voo" component={FlightReportsIndex} />
                  {/* AircraftLogbooks (EDB) */}
                  <Route path="/aeronave/diario/resetar" component={AircraftLogbookReset} />
                  <Route path="/aeronave/diario/dashboard" component={AircraftLogbooksDashboard} />
                  <Route path="/aeronave/diarios" component={AircraftLogbooksIndex} />
                  <Route path="/aeronave/diario/cadastrar" component={AircraftLogbooksAdd} />
                  <Route path="/aeronave/diario/pesquisa" component={AircraftLogbooksSearch} />
                  <Route path="/aeronave/diario/editar/:id" component={AircraftLogbooksEdit} />
                  {/* AircraftLogbookReportActionDeferredItems (EDB ACR) */}
                  <Route path="/aeronave/diario/acrs/abertos" component={AircraftLogbookReportActionsIndexOpened} />
                  <Route path="/aeronave/diario/acrs/fechados" component={AircraftLogbookReportActionsIndexClosed} />
                  <Route path="/aeronave/diario/acr/editar/:id" component={AircraftLogbookReportActionEdit} />
                  {/* FlightReport - Controles */}
                  <Route path="/relatorio/voo/quantidade" component={FlightReportQuantity} />
                  <Route path="/relatorio/voo/aprovacoes/pendentes" component={FlightReportApprovals} />
                  <Route path="/relatorio/voo/aeronaves/contratadas" component={FlightReportsAircrafts} />
                  <Route path="/relatorio/voo/pesquisa" component={FlightReportsMain} />
                  <Route path="/relatorio/voo/abastecimento" component={FlightReportsRefuels} />
                  <Route path="/relatorio/voo/consumo/disponibilidade" component={FlightReportsConsumptionDisponibility} />
                  <Route path="/relatorio/voo/consumo" component={FlightReportsConsumption} />
                  <Route path="/relatorio/voo/tripulantes" component={FlightReportsStaffHours} />
                  <Route path="/relatorio/voo/ocorrencias/anormais" component={FlightReportsAbnormalOcurrences} />
                  <Route path="/relatorio/voo/destinos" component={FlightReportsDestinies} />
                  <Route path="/relatorio/voo/pousos" component={FlightReportsLandingTimes} />
                  <Route path="/relatorio/voo/carga/externa" component={FlightReportsPayloads} />
                  <Route path="/relatorio/voo/diferenca/trechos" component={FlightReportsLegDifferences} />
                  <Route path="/relatorio/voo/consulta/indisponibilidade" component={FlightReportsAvailabilitiesSearch} />
                  <Route path="/relatorio/voo/boletim/disponibilidade" component={FlightReportsAvailabilities} />
                  <Route path="/relatorio/voo/apuracao/horas" component={FlightReportsHoursReport} />
                  <Route path="/relatorio/voo/conferencia/medicao" component={FlightReportsMeasurementCheck} />
                  <Route path="/relatorio/voo/pontualidade" component={FlightReportsPontuality} />
                  <Route path="/relatorio/voo/xml/bloco" component={FlightReportsXMLMultiple} />
                  <Route path="/relatorio/voo/db/bloco" component={FlightReportsDBMultiple} />
                  <Route path="/relatorio/voo/main/bloco" component={FlightReportsMainMultiple} />
                  <Route path="/controle/experiencia/noturna" component={NightimeExperience} />
                  <Route path="/controle/tarifas" component={FlightReportLegFees} />
                  {/* Training */}
                  <Route path="/treinamento/cadastrar" component={TrainingsAdd} />
                  <Route path="/treinamento/editar/:id" component={TrainingsEdit} />
                  <Route path="/treinamentos" component={TrainingsIndex} />
                  <Route path="/escala/treinamentos/duplicar/:id" component={ScheduleTrainingsDuplicate} />
                  <Route path="/escala/treinamentos/grade/:id" component={ScheduleGradesTrainings} />
                  <Route path="/escala/treinamentos/cadastrar" component={ScheduleTrainingsAdd} />
                  <Route path="/escala/treinamentos/editar/:id" component={ScheduleTrainingsEdit} />
                  <Route path="/escala/treinamentos" component={ScheduleTrainingsIndex} />

                  {/* Supplier */}
                  <Route path="/fornecedor/cadastrar" component={SuppliersAdd} />
                  <Route path="/fornecedor/editar/:id" component={SuppliersEdit} />
                  <Route path="/fornecedores" component={SuppliersIndex} />
                  {/* CertificationSupplier */}
                  <Route path="/certificados/vencimento" component={CertificationSuppliersToExpireIndex} />
                  {/* Certification */}
                  <Route path="/certificado/cadastrar" component={CertificationsAdd} />
                  <Route path="/certificado/editar/:id" component={CertificationsEdit} />
                  <Route path="/certificados/geral" component={CertificationsCompleteIndex} />
                  <Route path="/certificados" component={CertificationsIndex} />
                  {/* Contract */}
                  <Route path="/contrato/consulta" component={ContractsSearch} />
                  <Route path="/contrato/cadastrar" component={ContractsAdd} />
                  <Route path="/contrato/editar/:id" component={ContractsEdit} />
                  <Route path="/contratos" component={ContractsIndex} />
                  {/* Designation */}
                  <Route path="/designacao/cadastrar" component={DesignationsAdd} />
                  <Route path="/designacao/editar/:id" component={DesignationsEdit} />
                  <Route path="/designacoes" component={DesignationsIndex} />
                  {/* Designation */}
                  <Route path="/experiencia/minima/editar" component={WarningExperiencesEdit} />
                  {/* Client */}
                  <Route path="/cliente/cadastrar" component={ClientsAdd} />
                  <Route path="/cliente/editar/:id" component={ClientsEdit} />
                  <Route path="/clientes" component={ClientsIndex} />
                  {/* ScheduleInitials */}
                  <Route path="/sigla/cadastrar" component={ScheduleInitialsAdd} />
                  <Route path="/sigla/editar/:id" component={ScheduleInitialsEdit} />
                  <Route path="/siglas" component={ScheduleInitialsIndex} />
                  {/* ScheduleRegime */}
                  <Route path="/escala/regimes/:type" component={ScheduleRegime} />
                  {/* DrowsinessSchedules */}
                  <Route path="/escala/sonolencia/editar/:id" component={DrowsinessSchedulesEdit} />
                  <Route path="/escala/sonolencia/cadastrar" component={DrowsinessSchedulesAdd} />
                  <Route path="/escalas/sonolencia" component={DrowsinessSchedulesIndex} />
                  {/* StaffFlightTotals */}
                  <Route path="/disponibilidade/tripulantes" component={StaffFlightTotalsDisponibility} />
                  {/* ScheduleBases */}
                  <Route path="/escala/base/cadastrar" component={ScheduleBasesAdd} />
                  <Route path="/escala/base/editar/:id" component={ScheduleBasesEdit} />
                  <Route path="/escala/programacao/editar/:id" component={SchedulePlanningEdit} />
                  <Route path="/escala/programacao/cadastrar" component={SchedulePlanningAdd} />
                  <Route path="/escalas/programacao" component={SchedulePlanningIndex} />
                  <Route path="/simular/escala/programacao" component={SchedulePlanningSimulation} />
                  <Route path="/escala/mestre-de-carga/cadastrar" component={ScheduleMasterAdd} />
                  <Route path="/escala/mestre-de-carga/editar/:id" component={ScheduleMasterEdit} />
                  <Route path="/escalas/mestre-de-carga" component={ScheduleMasterIndex} />
                  <Route path="/escala/cvo/cadastrar" component={ScheduleCvoAdd} />
                  <Route path="/escala/cvo/editar/:id" component={ScheduleCvoEdit} />
                  <Route path="/escala/mestre-de-carga/duplicar/:id" component={ScheduleMasterDuplicate} />
                  <Route path="/escala/cvo/duplicar/:id" component={ScheduleCvoDuplicate} />
                  <Route path="/escalas/cvo" component={ScheduleCvoIndex} />
                  <Route path="/escalas/base" component={ScheduleBasesIndex} />
                  <Route path="/escala/base/grade/:id" component={ScheduleGradeBaseEdit} />
                  {/* Schedules */}
                  <Route path="/escala/cadastrar" component={SchedulesAdd} />
                  <Route path="/escala/elaborar" component={SchedulesElaborate} />
                  <Route path="/escala/editar/:id" component={SchedulesEdit} />
                  <Route path="/escala/duplicar/:id" component={SchedulesDuplicate} />
                  <Route path="/escalas" component={SchedulesIndex} />
                  {/* ScheduleGrades */}
                  <Route path="/escala/grade/alertas/:id" component={ScheduleGradeAlerts} />
                  <Route path="/escala/grade/:id" component={ScheduleGradesEdit} />
                  <Route path="/escala/alternativa/grade/:id" component={ScheduleGradesAlternate} />
                  {/* StaffIncompatibilities */}
                  <Route path="/incompatibilidades" component={IncompatibilitiesIndex} />
                  {/* TrainingCertificationStaffPayments */}
                  <Route path="/pagamento/horas/cadastrar" component={PaymentHoursAdd} />
                  <Route path="/pagamento/diarias/cadastrar" component={PaymentDailyAdd} />
                  <Route path="/pagamento/diarias/internacional/cadastrar" component={PaymentDailyInternationalAdd} />
                  <Route path="/pagamento/extra/cadastrar" component={PaymentDailyExtraAdd} />
                  <Route path="/pagamentos/abertos/horas" component={PaymentHoursOpened} />
                  <Route path="/pagamentos/abertos/diarias" component={PaymentDailyOpened} />
                  <Route path="/pagamentos/abertos/extras" component={PaymentDailyExtraOpened} />
                  <Route path="/cheques/abertos" component={PaymentCheckOpened} />
                  <Route path="/saldo/devedor" component={StaffDebt} />
                  <Route path="/pagamentos/saldo/debito/cadastrar" component={PaymentDebtAdd} />
                  <Route path="/pagamentos/saldo/debito/editar/:id" component={PaymentDebtEdit} />
                  <Route path="/pagamentos/saldo/credito/cadastrar" component={PaymentCreditAdd} />
                  <Route path="/pagamentos/saldo/credito/editar/:id" component={PaymentCreditEdit} />
                  {/* SchedulePayments */}
                  <Route path="/escala/pagamento/horas/cadastrar" component={SchedulePaymentHoursAdd} />
                  <Route path="/escala/pagamento/diarias/cadastrar" component={SchedulePaymentDailyAdd} />
                  <Route path="/escala/pagamento/extra/cadastrar" component={SchedulePaymentExtraAdd} />
                  <Route path="/escala/pagamento/deslocamento/cadastrar" component={SchedulePaymentDistanceAdd} />
                  <Route path="/escala/pagamento/transporte/cadastrar" component={SchedulePaymentTransportAdd} />
                  <Route path="/escala/base/pagamento/diarias/cadastrar" component={SchedulePaymentDailyBaseAdd} />
                  <Route path="/escala/pagamentos/abertos/horas" component={SchedulePaymentHoursOpened} />
                  <Route path="/escala/pagamentos/abertos/diarias" component={SchedulePaymentDailyOpened} />
                  <Route path="/escala/pagamentos/abertos/representante" component={SchedulePaymentBaseChiefOpened} />
                  <Route path="/escala/pagamentos/abertos/deslocamento" component={SchedulePaymentDistanceOpened} />
                  <Route path="/escala/pagamentos/abertos/transporte" component={SchedulePaymentTransportOpened} />
                  <Route path="/escala/pagamentos/abertos/extra" component={SchedulePaymentExtraOpened} />
                  {/* Payments */}
                  <Route path="/gerar/pagamentos" component={StaffFlightPaymentHoursOpened} />
                  <Route path="/lista/solicitacao/pagamento/deslocamento/missao" component={PaymentRequestScheduleDistanceIndex} />
                  <Route path="/lista/solicitacao/pagamento/deslocamento/treinamento" component={PaymentRequestTrainingDistanceIndex} />
                  <Route path="/lista/solicitacao/pagamento/transporte/missao" component={PaymentRequestScheduleTransportIndex} />
                  <Route path="/lista/solicitacao/pagamento/transporte/treinamento" component={PaymentRequestTrainingTransportIndex} />
                  {/* PaymentValues */}
                  <Route path="/pagamento/valores" component={PaymentValuesEdit} />
                  {/* PaymentValues */}
                  <Route path="/ordens/pagamentos/abertas" component={PaymentOrdersOpenedIndex} />
                  <Route path="/ordens/pagamentos/enviadas" component={PaymentOrdersSentIndex} />
                  <Route path="/ordem/pagamento/cadastrar" component={PaymentOrdersAdd} />
                  <Route path="/ordem/pagamento/editar/:id" component={PaymentOrdersEdit} />
                  {/* Process */}
                  <Route path="/gratificacao/cadastrar" component={GratificationsAdd} />
                  <Route path="/gratificacao/editar/:id" component={GratificationsEdit} />
                  <Route path="/gratificacoes" component={GratificationsIndex} />
                  {/* Process */}
                  <Route path="/processo/cadastrar" component={ProcessesAdd} />
                  <Route path="/processo/editar/:id" component={ProcessesEdit} />
                  <Route path="/processos" component={ProcessesIndex} />
                  {/* Document*/}
                  <Route path="/documento/cadastrar" component={DocumentsAdd} />
                  <Route path="/documento/editar/:id" component={DocumentsEdit} />
                  <Route path="/documentos" component={DocumentsIndex} />
                  {/* Email*/}
                  <Route path="/email/editar/:id" component={EmailsEdit} />
                  <Route path="/emails" component={EmailsIndex} />
                  {/* UsefulLinks*/}
                  <Route path="/links/uteis" component={UsefulLinksIndex} />

                  {/* Log*/}
                  <Route path="/logs" component={LogsIndex} />
                  {/* Importações*/}
                  <Route path="/importacoes" component={ImportIndex} />
                  {/* User*/}
                  <Route path="/usuario/editar/:id" component={UsersEdit} />
                  <Route path="/usuario/cadastrar" component={UsersAdd} />
                  <Route path="/usuario/nova/senha" component={UsersEditPassword} />
                  <Route path="/usuarios" component={UsersIndex} />
                  {/* Teste de alerta */}
                  <Route path="/testar/alertas" component={TestAlertsIndex} />
                  {/* Relatorios / FatigueReason /Teste de sonolência */}
                  <Route promptInstall={this.promptInstall} path="/administrativo/relatorio-de-fadiga/cadastrar" render={(props) => <StaffRfmsReportAdmAdd {...props} promptInstall={this.promptInstall} />} />
                  <Route promptInstall={this.promptInstall} path="/relatorio-de-fadiga/tripulante/administrativo/editar/:id/:applicability_id/:staff_id" render={(props) => <StaffRfmsReportAdmEdit {...props} promptInstall={this.promptInstall} />} />
                  <Route path="/relatorios-de-fadiga/faltantes" component={StaffRfmsReportMissing} />
                  <Route path="/relatorios-de-fadiga/pesquisa" component={StaffRfmsReportSearch} />
                  <Route path="/relatorios-de-fadiga/incorretos" component={StaffRfmsReportAdjustHours} />
                  <Route path="/relatorio-de-fadiga/cadastrar" component={StaffRfmsReportAdd} />
                  <Route path="/relatorios-de-fadiga/tripulante" component={StaffRfmsReportIndex} />
                  <Route path="/relatorios-de-fadiga/monitoramento" component={StaffRfmsReportFilter} />
                  <Route path="/relatorios-de-fadiga/incidentes" component={StaffRfmsReportIncidentFatigueFilter} />
                  <Route path="/relatorio-de-fadiga/tripulante/editar/:id" component={StaffRfmsReportEdit} />
                  <Route path="/simular/relatorios-de-fadiga" component={SimulatorStaffRfmsReport} />
                  <Route path="/relatorios-de-fadiga/autoavaliacao" component={SearchAuxiliaryReport} />
                  {/* Solicitações de escala */}
                  <Route path="/chefe/frota/resposta/solicitacao/escala/:token" component={StaffScheduleRequestsChiefAnswer} />
                  <Route path="/solicitacao/escala/todas" component={StaffScheduleRequestsIndex} />
                  <Route path="/solicitacao/escala/pendentes" component={StaffScheduleRequestsPending} />
                  {/* Pendnecias de escala */}
                  <Route path="/escala/pendencias/abertas" component={SchedulePendenciesPending} />
                  <Route path="/escala/pendencias/resolvidas" component={SchedulePendenciesIndex} />
                  {/* Fadiga / Fatigue */}
                  <Route path="/parametro-de-fadiga/cadastrar" component={FatigueAdd} />
                  <Route path="/parametros-de-fadiga" component={FatigueIndex} />
                  <Route path="/parametro-de-fadiga/editar/:id" component={FatigueEdit} />
                  <Route path="/configuracoes/pontuacao" component={SettingsEdit} />
                  <Route path="/fadiga/motivos" component={FatigueReasonsEdit} />
                  <Route path="/reporte/voluntario/fadiga/abertos" component={FatigueReasonReportsIndex} />
                  <Route path="/reporte/voluntario/fadiga/fechados" component={FatigueReasonReportsArchived} />
                  <Route path="/reporte/voluntario/fadiga" component={FatigueReasonReportsAdd} />
                  <Route path="/relatorios-de-fadiga/eventos" component={StaffRfmsReportEvents} />
                  <Route path="/sigla/relatorios-de-fadiga/cadastrar" component={StaffRfmsReportSiglaAdd} />
                  <Route path="/sigla/relatorios-de-fadiga/avaliar" component={StaffRfmsReportSiglaAvaliation} />
                  {/* EffectivenessSections */}
                  <Route path="/secao-de-efetividade/editar/:id" component={EffectivenessSectionsEdit} />
                  <Route path="/secoes-de-efetividade/cadastrar" component={EffectivenessSectionsAdd} />
                  <Route path="/secoes-de-efetividade" component={EffectivenessSectionsIndex} />
                  <Route path="/formularios" component={FatigueEffectivenessIndex} />
                  <Route path="/formulario/editar/:id" component={FatigueEffectivenessEdit} />
                  <Route path="/formulario/mensal/estatisticas" component={FatigueEffectivenessSearch} />
                  <Route path="/formulario/mensal" component={FatigueEffectivenessAdd} />
                  {/* Task */}
                  <Route path="/tarefas/cadastrar" component={TasksAdd} />
                  <Route path="/tarefa/editar/:id" component={TasksEdit} />
                  <Route path="/tarefas" component={TasksIndex} />
                  {/* FatigueTests */}
                  <Route promptInstall={this.promptInstall} path="/questionario/pesquisa/repostas" component={FatigueTestsIndex} />
                  {/* Warning */}
                  <Route path="/alerta/editar/:id" component={WarningsEdit} />
                  <Route path="/alertas" component={WarningsIndex} />
                  {/* Home */}
                  <Route path="/" component={StaffsIndex} />
                </Switch>
              </BrowserRouter>
            </div>
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js